import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons';

const ForbiddenScreen: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
            <div className="w-20 h-20 rounded-2xl bg-danger-light flex items-center justify-center mb-6">
                <FontAwesomeIcon icon={faShieldHalved} className="text-3xl text-danger" />
            </div>
            <h1 className="text-6xl font-bold text-slate-900 mb-2">403</h1>
            <p className="text-lg text-slate-500 mb-6">{t('messages.page_forbidden')}</p>
            <a href="/home" className="btn-primary-tw text-sm no-underline">
                {t('menu.home')}
            </a>
        </div>
    );
};

export default ForbiddenScreen;
